import React, { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import { api } from "@/lib/api";
import { SITE as STATIC_SITE, CATEGORIES as STATIC_CATEGORIES } from "@/data/site";

const SiteContext = createContext(null);
export const useSite = () => useContext(SiteContext);

const fallbackSettings = {
  brand_name: STATIC_SITE.short === "ADAM'S" ? "Adam's" : STATIC_SITE.name,
  brand_tagline: "The Islamic Boutique",
  logo_url: "/brand-logo.png",
  whatsapp: STATIC_SITE.whatsapp,
  whatsapp_display: STATIC_SITE.whatsappDisplay,
  instagram: STATIC_SITE.instagram,
  instagram_url: STATIC_SITE.instagramUrl,
  email: STATIC_SITE.email,
  phone: STATIC_SITE.phone,
  announcement: "Free Shipping Across India On Orders Above ₹4999",
};

export function SiteProvider({ children }) {
  const [settings, setSettings] = useState(fallbackSettings);
  const [categories, setCategories] = useState(STATIC_CATEGORIES);

  const refresh = useCallback(async () => {
    try {
      const [s, c] = await Promise.all([api.get("/settings"), api.get("/categories")]);
      setSettings({ ...fallbackSettings, ...s.data });
      if (Array.isArray(c.data) && c.data.length) setCategories(c.data);
    } catch (e) {
      console.error("Failed to load site settings/categories; using fallbacks", e);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const value = useMemo(() => ({ settings, categories, refresh }), [settings, categories, refresh]);

  return (
    <SiteContext.Provider value={value}>
      {children}
    </SiteContext.Provider>
  );
}
